import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const ToolbarContainer = styled.div`
  min-height: 50px;
  width: 100%;
  background-color: ${ColorSF2.white};
  display: flex;
  align-items: stretch;
  justify-content: start;
  padding: 10px;
`;

export const ExecuteBox = styled.div`
  display: flex;
  align-items: center;
`;

export const SelectBox = styled.div`
  margin-left: 10px;
  color: ${ColorSF2.black};
`;

export const Button = styled.div`
  width: 59px;
  height: 31px;
  border-radius: 5px;
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  color: ${props => (props.disabled ? ColorSF2.black : ColorSF2.white)};
  background-color: ${props =>
    props.disabled ? ColorSF2.lightGray : ColorSF2.green};
`;

export const SelectExecute = styled.select`
  color: ${ColorSF2.white};
  &.selected {
    color: ${ColorSF2.black};
  }
`;
